class LazyYoutube {
  constructor(el) {
    this.el = el
    this.width = Number(this.el.getAttribute('width'))
    this.height = Number(this.el.getAttribute('height'))
    this.src = new URL(this.el.getAttribute('data-src'))
    const srcArray = this.src.pathname.split('/')
    this.youtubeId = srcArray[srcArray.length - 1]

    // this.thumbSrc = 'https://i.ytimg.com/vi/' + srcArray[srcArray.length - 1] + '/hqdefault.jpg'
    this.thumbSrc = 'https://i.ytimg.com/vi/' + srcArray[srcArray.length - 1] + '/sddefault.jpg'
    this.container = this.createContainer()
    this.el.parentNode.insertBefore(this.container, this.el)
    this.el.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    `
    this.container.appendChild(this.el)
    this.thumb = this.createThumb()
    this.container.appendChild(this.thumb)

    this.button = this.createButton()
    this.container.appendChild(this.button)
  }
  createContainer() {
    const container = document.createElement('div')
    container.classList.add('js-lazyload-youtube-container')
    container.style.position = 'relative'
    container.style.aspectRatio = '16 / 9'
    return container
  }
  createThumb() {
    const thumb = new Image()
    thumb.classList.add('js-lazyload-youtube-thumb')
    thumb.style.cssText = `
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    pointer-events:none;
    `
    thumb.loading = 'lazy'
    thumb.decoding = 'async'
    thumb.setAttribute('src', this.thumbSrc)
    return thumb
  }
  createButton() {
    const button = document.createElement('span')
    button.classList.add('youtube-button')
    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path fill="currentColor" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><polygon fill="#fff" points="232.1,337.6 232.1,175.2 374.9,256.4 232.1,337.6 "/></svg>`
    button.addEventListener('click', () => {
      this.activate()
    })
    return button
  }
  activate() {
    this.el.setAttribute('src', this.src + '?autoplay=1')
    this.container.removeChild(this.thumb)
    this.container.removeChild(this.button)
  }
}

export class LazyYoutubes {
  constructor() {
    this.youtubesEl = [...document.getElementsByClassName('js-lazyload-youtube')]
    if (this.youtubesEl.length === 0) return
    this.youtubes = this.youtubesEl
      .map((youtubeEl) => {
        if (youtubeEl.getAttribute('data-src')) {
          return new LazyYoutube(youtubeEl)
        }
      })
      .filter((e) => e)
  }
}
